import React from "react";

export default function Loading() {
  return (
    <div className="flex h-screen">
      <i className="fas fa-spinner fa-spin m-auto text-5xl text-green-500"></i>
    </div>
  );
}
